module.exports = __webpack_public_path__ + "img/x5.8627fb6c.png";